import { ObservationService } from '../../shared/observation/observation.service';
import { CertificationActivityService } from '../shared/certification-activity.service';
import { CreditTypeDto } from '../shared/dto/credit-type.dto';
import { CreditTypeService } from '../shared/credit-type.service';
import { SelectItem } from 'primeng/api';
import { PagedResultGeneric } from '../../shared/model/paged-result.model';
import { CertificationActivitySourceDto } from '../shared/dto/certification-activity-source.dto';
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CertificationActivityDto } from '../shared/dto/certification-activity.dto';
import { CertificationActivitySourceService } from '../shared/certification-activity-source.service';
import { FormControl } from '@angular/forms';
import { CreditTypeSearchDto } from '../shared/dto/credit-type-search.dto';

@Component({
  selector: 'wl-ceu-edit-dialog',
  templateUrl: './ceu-edit-dialog.component.html',
  styleUrls: ['./ceu-edit-dialog.component.less'],
    standalone: false
})
export class CeuEditDialogComponent implements OnInit, OnChanges {
  @Input() activity: CertificationActivityDto;
  @Input() show: boolean;
  @Input() profileId: number;

  public activitySources: CertificationActivitySourceDto[] = [];
  public creditTypes: CreditTypeDto[] = [];
  public today = new Date();

  constructor(
    private _certificationActivityService: CertificationActivityService,
    private _certificationActivitySourceService: CertificationActivitySourceService,
    private _creditTypeService: CreditTypeService,
    private _observationService: ObservationService
  ) {}

  ngOnInit(): void {
    this.activity = {} as CertificationActivityDto;

    this._certificationActivitySourceService.getAllSources().then((data: PagedResultGeneric<CertificationActivitySourceDto>) => {
      this.activitySources = data.Result;
    });

    const typeSearchDto = new CreditTypeSearchDto();
    typeSearchDto.PageSize = 0;
    this._creditTypeService.getAllCreditTypes(typeSearchDto).then((data: PagedResultGeneric<CreditTypeDto>) => {
      this.creditTypes = data.Result;
    });
  }

  ngOnChanges(changes: SimpleChanges) {}

  public cancel() {
    this.show = false;
  }

  public save() {
    if (!this.activity.CertificationActivityID) {
      this._certificationActivityService.create(this.activity).then(() => {
        this._observationService.profileUpdated(this.profileId);
        this.show = false;
      });
    } else {
      this._certificationActivityService.update(this.activity).then(() => {
        this._observationService.profileUpdated(this.profileId);
        this.show = false;
      });
    }
  }
}
